module.exports = __webpack_public_path__ + "assets/2_3_3_IFOK_WIM_STUSTAINABILITY_Enviroment_Plattform_for_svg_je.e936d5cb.svg";